<template>
  <div class="h-panel-body padding">
    <div class="text-right margin-bottom">
      <Button color="primary" :loading="loading" @click="saveOrgMapping">保存映射并关联</Button>
    </div>
    <vxe-table border show-overflow size="mini" :data="datas" highlight-hover-row>
      <vxe-column field="state" title="关联状态" width="100">
        <template #default="{row}">
          {{ row.id === currentAccountSets.id && currentOrg ? '已关联' : '未关联' }}
        </template>
      </vxe-column>
      <vxe-column field="companyName" title="财务软件账套"/>
      <vxe-column title="进销存账套">
        <template #default="{row}">
          {{ row.id === currentAccountSets.id && currentOrg ? currentOrg.name : '-' }}
        </template>
      </vxe-column>
      <vxe-column title="操作" width="200">
        <template #default="{row}">
          <span class="actions" v-if="row.id === currentAccountSets.id" @click="saveOrgMapping">关联门店</span>
        </template>
      </vxe-column>
    </vxe-table>
  </div>
</template>

<script>
import {mapState} from "vuex";

/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2020 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : financial</li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2022/6/13 15:13</li>
 * <li>@author     : ____′↘TangSheng</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
export default {
  name: "LinkJxcAccountSet",
  data() {
    return {
      datas: [],
      loading: false,
    }
  },
  computed: {
    ...mapState(["currentAccountSets", "currentOrg"])
  },
  methods: {
    initOrganization() {
      this.$api.setting.Inventory.org().then(({data}) => {
        this.$store.commit('updateJxcOrg', data && data.length ? data[0] : null);
      })
    },
    saveOrgMapping() {
      this.loading = true;
      //必须提交进销存组织（/inventory/org），不能提交 store.orgDatas（那是财务账套列表）
      this.$api.setting.Inventory.org().then(({data}) => {
        let list = data || [];
        if (!list.length) {
          this.$Message.error('未获取到进销存组织，请稍后重试');
          return;
        }
        return this.$api.setting.organization.mapping(list).then(() => {
          this.$Message('映射成功~');
          this.$store.dispatch('init');
          this.initOrganization();
        });
      }).finally(() => this.loading = false);
    },
    loadList() {
      this.$api.setting.accountSets.list().then(({data}) => {
        this.datas = data || [];
      })
    },
  },
  created() {
    this.loadList();
    if (this.currentAccountSets.token) {
      this.initOrganization();
    }
  }
}
</script>


<style scoped lang="less">
.box {
  .form {
    border: @border;
    margin: 30px auto;
    padding: 30px;
    width: 800px;
  }

  .sys-border {
    padding-left: 10px !important;
    border: 1px solid #f1556c;
  }
}
</style>
